import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Popover,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EmailPatientPicker, { patientName } from "./EmailPatientPicker";

const PATIENT_CONTROL_WIDTH = 180;

const EmailPatientDirectory = ({ selectedPatientId, selectedScope, onSelectPatient }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (!selectedPatientId) {
      setSelectedPatient(null);
    }
  }, [selectedPatientId]);

  const selectedLabel = (() => {
    if (selectedScope === "unmatched") return "Unmatched";
    if (selectedPatientId) return selectedPatient ? patientName(selectedPatient) : "Patient selected";
    return "All Patients";
  })();

  const handleSelect = (patient, scope) => {
    setSelectedPatient(scope === "patient" ? patient : null);
    onSelectPatient(patient, scope);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant={selectedScope === "patient" || selectedScope === "unmatched" ? "contained" : "outlined"}
        size="small"
        startIcon={<MenuIcon fontSize="small" />}
        endIcon={<KeyboardArrowDownIcon fontSize="small" />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-label="Select patient"
        sx={{
          width: PATIENT_CONTROL_WIDTH,
          height: 40,
          position: "relative",
          justifyContent: "center",
          px: 4,
          "& .MuiButton-startIcon": {
            position: "absolute",
            left: 12,
            margin: 0,
          },
          "& .MuiButton-endIcon": {
            position: "absolute",
            right: 12,
            margin: 0,
          },
        }}
      >
        <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {selectedLabel}
        </Box>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            mt: 0.75,
            width: PATIENT_CONTROL_WIDTH,
            maxWidth: "calc(100vw - 32px)",
            borderRadius: 0,
            border: "1px solid #000",
          },
        }}
      >
        <EmailPatientPicker
          selectedPatientId={selectedPatientId}
          selectedScope={selectedScope}
          includeAll
          includeUnmatched
          onSelectPatient={handleSelect}
          height={520}
        />
      </Popover>
    </>
  );
};

export default EmailPatientDirectory;
